import { render, staticRenderFns } from "./_folder_form.vue?vue&type=template&id=4443e882&scoped=true&"
import script from "./_folder_form.vue?vue&type=script&lang=js&"
export * from "./_folder_form.vue?vue&type=script&lang=js&"
import style0 from "./_folder_form.vue?vue&type=style&index=0&id=4443e882&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4443e882",
  null
  
)

export default component.exports